// Keyboard vs pointer focus (WCAG 2.4.7). Adds "dwao-pointer-focus" to <html>
// while the visitor is using a mouse, pen or touch, and removes it as soon as
// they use the keyboard. Stylesheets use it to keep the focus ring for keyboard
// users without showing it after a mouse click into a text field
// (common/scss/_base.scss). Only Tab switches back to keyboard mode, so typing
// into a field that was clicked does not make its ring appear.
const POINTER_CLASS = "dwao-pointer-focus";
const root = document.documentElement;

document.addEventListener("pointerdown", () => {
    root.classList.add(POINTER_CLASS);
}, true);

document.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
        root.classList.remove(POINTER_CLASS);
    }
}, true);
